import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import "./AdminPage.css";
import { useMsal } from "@azure/msal-react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Alert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { fetchSessions, uploadFile } from "../../Redux/AdminSlice";
import SampleExcel from "../../../data/CalendarData.xlsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "0.1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "0px",
  padding: "36px !important",
};

const AdminPage = ({ setBool }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [successAlert, setSuccessAlert] = useState(false);

  const { instance } = useMsal();
  const [showUser, setShowUser] = useState(false);
  const [country, setCountry] = useState("India");

  let atci_lkm_lis_portal_development = "ATCI.L-TT.LX.PORTALDEVELOPMENT";
  let domain = "accenture.com";

  const usersList = [
    "arpita.m.singh",
    "varsha.a.tyagi",
    "h.srinivasan",
    "jeevadharani.ramanan",
    "aluru.akash",
    "aayushi.bharti",
    "uma.rani.battu",
    "ankur.e.mishra",
    "reshmi.haridas.m",
    "kusume.sridhar",
    "potnuru.sandeep",
    "lakshay.c.gupta",
  ];
  const activeAccount = instance.getActiveAccount();
  let activeUsername = "";
  if (activeAccount) activeUsername = activeAccount.username;

  useEffect(() => {
    if (
      activeAccount &&
      activeAccount.idTokenClaims &&
      usersList.includes(activeAccount.idTokenClaims.enterpriseID)
    ) {
      setShowUser(true);
    }
  }, [instance]);
  const dispatch = useDispatch();
  const { sessions, success, isLoading, error } = useSelector(
    (state) => state.admin,
  );

  useEffect(() => {
    dispatch(fetchSessions());
  }, [dispatch]);

  const onFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    setFileName(selected ? selected.name : "");
  };

  const onUpload = async (e) => {
    e.preventDefault();
    if (!file) return window.alert("Select a file first");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("country", country);
    dispatch(uploadFile(formData));
    handleClose();
  };

  return (
    <>
      <div className="alert-container">
        {successAlert && (
          <Alert onClose={() => setSuccessAlert(false)} className="alert-line">
            Updated Successfully!!
          </Alert>
        )}
      </div>
      {showUser && (
        <div className="admin_container">
          {/* MUI Modal  */}
          <Button onClick={handleOpen} className="admin-button">
            Admin
          </Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal-box-container">
              <div className="modal-box-wrap">
                <h2>File Upload</h2>
                <hr></hr>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/LearningCalendar/CloseIcon.png"
                  }
                  onClick={handleClose}
                  alt="close-icon"
                  className="close-button"
                ></img>

                <form onSubmit={onUpload} className="modal-box-form" id="form">
                  <div>
                    <label>Select File to Upload :</label>
                    <div className="upload-form">
                      <input
                        type="file"
                        className="mainData"
                        accept=".xlsx"
                        id="file"
                        onChange={onFileChange}
                        aria-label="file"
                      />
                      <label htmlFor="file" className="file_lable">
                        &uArr; Upload File
                      </label>
                      <span className="file_caption">
                        {fileName ? fileName : "No File Selected"}
                      </span>
                    </div>
                    <div className="country-select-container">
                      <label htmlFor="country">Select Country :</label>

                      <select
                        id="country"
                        className="country-select"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                      >
                        <option value="">Select Country</option>
                        <option value="India">India</option>
                      </select>
                    </div>
                  </div>
                  <div className="submit-btn-container">
                    <Button
                      type="submit"
                      className="submit-btn"
                      disabled={!file || !country}
                    >
                      Publish Data
                    </Button>
                  </div>
                </form>
                <div className="instructions-container">
                  <span className="key-statistics-upload-instructions">
                    Instructions
                  </span>
                  <div>
                    <ol className="Instructions-List">
                      {/* <li>
                        To publish the calendar by uploading the template, in
                        case if there is any doubt or clarification please refer
                        the{" "}
                        <a
                          href="images/L&TTCALENDAR-Job-Aid.docx"
                          className="lkm-calendar-sample-file"
                        >
                          job aid
                        </a>
                        .
                      </li> */}
                      <li>
                        The calendar needs to be uploaded in a given template
                        format. Any change in the template will lead to upload
                        failure or error messages.
                        <a
                          href={SampleExcel}
                          download="CalendarData.xlsx"
                          target="_blank"
                          className="lkm-calendar-sample-file"
                          rel="noreferrer"
                        >
                          {" "}
                          Click here{" "}
                        </a>
                        to download the calendar template.
                      </li>
                      {/* <li>
                        {" "}
                        Also please make sure the column data "SessionStartDate"
                        and "SessionEndDate" must be in "YYYY-MM-DD" format. For
                        eg. 2023-08-14
                      </li> */}
                      {/* <li>Please make sure the excel file to be uploaded must be named as "CalendarData.xlsx". Any change in the file name will lead to upload failure.</li> */}
                      <li>
                        For a successful upload of new calendar data every time
                        use new excel file, avoid making changes to the older
                        one.
                      </li>
                      <li>
                        Please avoid uploading or updating the calendar
                        frequently to avoid any issues. In case if any
                        corrections required and its unavoidable please
                        re-upload the calendar again and publish the calendar.
                      </li>
                      {/* <li>
                              Please do not exceed maximum three times of uploading or correcting the calendar for the respective 
                              month as per the governance and terms.
                          </li>*/}
                      <li>
                        Uploaded calendar can be modified to the max of 5 times.
                      </li>
                      <li>
                        In case if you need to add or remove access for admin
                        page please contact <br />{" "}
                        <a
                          href="mailto:ATCI.L-TT.LX.PORTALDEVELOPMENT;"
                          className="lkm-calendar-sample-file"
                        >
                          {atci_lkm_lis_portal_development}@{domain}
                        </a>
                      </li>
                      {/* <li>
                        Whenever there is a change in the calendar page, admins
                        will be notified via mail
                      </li>
                      <li>
                        The members who have admin access :
                        <table className="table_Names">
                          <tr>
                            <td>h.srinivasan</td>
                            <td>varsha.a.tyagi</td>
                            <td>jeevadharani.ramanan</td>
                            <td>arpita.m.singh</td>
                            <td>aluru.akash</td>
                          </tr>
                          <tr>
                            <td>uma.rani.battu</td>
                            <td>reshmi.haridas.m</td>
                            <td>ankur.e.mishra</td>
                            <td>aayushi.bharti</td>
                            <td>kusume.sridhar</td>
                          </tr>
                        </table>
                      </li> */}
                    </ol>
                  </div>
                </div>
              </div>
            </Box>
          </Modal>
        </div>
      )}
    </>
  );
};

export default AdminPage;
